import { Component, OnInit } from '@angular/core';

@Component({
    selector   : 'wtf-footer',
    templateUrl: './footer.component.html',
    styleUrls  : ['./footer.component.scss']
})
export class WtfFooterComponent implements OnInit
{

    constructor()
    {
    }

    ngOnInit()
    {
    }

}
